import Home from "./pages/Home";
import SingleEvent from "./pages/SingleEvent";
import ArchiveSpaces from "./pages/ArchiveSpaces";
import Menu from "./pages/Menu";
import SingleSpace from "./pages/SingleSpace";
import BookPanel from "./classes/BookPanel";

export default class app {
  constructor(data) {
    this.page = document.querySelector(".js-page");
    this.data = data;
  }

  init() {    
    this._initPageTemplate();
    this._initNavMenu();
    this._initBookPanel();
    this._initFakeTransitionBetweenPages();
    this._initBtnBack();
    this._patchCurrentNavVoiceLoftMenu("torino");
  }

  _initFakeTransitionBetweenPages() {
    if (document.querySelector("main")) {
      setTimeout(() => {
        document.querySelector("main").style.opacity = 1;
      }, 500);      
      let timeout;
      document.querySelectorAll("a")?.forEach(el => {
        if (
          el.getAttribute("target") !== "_blank"
          && el.href.length 
          && !el.href.includes(window.location.href)
        ) {
          el.addEventListener("click", (e) => {
            e.preventDefault();
            if (e.target.closest(".is-open")) e.target.closest(".is-open").classList.remove("is-open");
            document.querySelector("main").style.opacity = 0;
            clearTimeout(timeout);
            timeout = setTimeout(() => {
              window.location = el.href;
            }, 500);
          });
        }
      });
    }
  }

  _initPageTemplate() {
    switch(this.page?.dataset.page) {
      case "home":
        const PageHome = new Home(this.page, this.data);
        PageHome.init();
      break;
      case "single-evento":
        const PageSingleEvent = new SingleEvent(this.page);
        PageSingleEvent.init();
      break;
      case "archive-spaces":
        const PageArchiveSpaces = new ArchiveSpaces(this.page, this.data);
        PageArchiveSpaces.init();
        PageArchiveSpaces.initEntries();
      break;
      case "single-space":
        const PageSingleSpace = new SingleSpace(this.page, this.data);
        PageSingleSpace.init();
      break;
      case "menu":
        const PageMenu = new Menu(this.page);
        PageMenu.init();
        PageMenu.initMenus();
      break;
      default:
        console.log("Not an App template...");
    }
  }

  _initNavMenu() {
    const siteHeader = document.querySelector(".js-site-header");
    if (siteHeader) {
      const subMenusParents = siteHeader.querySelectorAll(".menu-item-has-children");
      const menuItems = siteHeader.querySelectorAll(".menu > .menu-item:not(.menu-item-has-children)");
      const btnOpenMobileMenu = siteHeader.querySelector(".js-menu-open");
      const btnCloseMobileMenu = siteHeader.querySelector(".js-menu-close");

      subMenusParents?.forEach((menuItem) => {
        menuItem.addEventListener("mouseenter", this._setVisibleSubMenu.bind(this));
        menuItem.addEventListener("click", this._slideDownSubMenu.bind(this));
        menuItem.querySelector(".sub-menu")?.addEventListener("mouseleave", this._hideVisibleSubMenu.bind(this));
      });

      menuItems?.forEach((voice) => {
        voice.addEventListener("mouseenter", (e) => siteHeader.querySelector(".is-selected")?.classList.remove("is-selected"));
      });

      btnOpenMobileMenu?.addEventListener("click", (e) => siteHeader.querySelector(".site-nav")?.classList.add("is-open"));
      btnCloseMobileMenu?.addEventListener("click", (e) => siteHeader.querySelector(".site-nav")?.classList.remove("is-open"));
    }    
  }

  _setVisibleSubMenu(e) {
    if (window.innerWidth > 991) {
      e.target.closest(".site-nav")?.querySelector(".is-selected")?.classList.remove("is-selected");

      if (!e.target.classList.contains("is-selected")) {
        e.target.classList.add("is-selected");      
      }
    }    
  }

  _hideVisibleSubMenu(e) {
    if (window.innerWidth > 991) {
      if (e.target.closest(".menu-item").classList.contains("is-selected")) {
        e.target.closest(".menu-item").classList.remove("is-selected");
      }
    }
  }

  _slideDownSubMenu(e) {    
    if (window.innerWidth < 992) {
      if (e.target.closest(".site-nav")?.querySelector(".is-selected") !== e.target) {
        e.target.closest(".site-nav")?.querySelector(".is-selected")?.classList.remove("is-selected");
        e.target.closest(".site-nav")?.querySelector(".is-visible")?.classList.remove("is-visible");    
      }
  
      e.target.classList.toggle("is-selected");
  
      if (e.target.classList.contains("is-selected")) {
        e.target.querySelector(".sub-menu")?.classList.add("is-visible");

      } else {
        e.target.querySelector(".sub-menu")?.classList.remove("is-visible");
      }
    }    
  }

  _initBookPanel() {
    const btnOpenPanel = document.querySelector(".js-book-panel-toggle");
    const panel = document.querySelector(".js-book-panel");
    const bookPanel = new BookPanel(btnOpenPanel, panel);
    bookPanel.init();    
  }  

  _initBtnBack() {
    const btn = document.querySelector(".js-btn-back");
    if (btn?.href === "javascript:;") {
      if (document.referrer === "" || document.referrer === null || document.referrer === undefined) {        
        btn?.remove();
        if (btn?.parentNode?.classList.contains("js-btn-back-wrap")) btn.parentNode.remove();
        if (btn?.nextElementSibling?.getAttribute("style") === "padding-top: 0;") {
          btn.nextElementSibling.removeAttribute("style");
        } else if (btn?.parentNode?.classList.contains("js-btn-back-wrap") && btn?.nextElementSibling?.getAttribute("style") === "padding-top: 0;") {
          btn.nextElementSibling.removeAttribute("style");
        }
      }
    }    
  }

  _patchCurrentNavVoiceLoftMenu(location) {
    const nav = document.querySelector(".js-site-header");
    if (nav?.querySelectorAll("a").length) {
      const voice = Array.from(nav.querySelectorAll("a")).filter( a => a.href === `${window.location.origin}/${location}` );      
      const body = document.body;

      if (body.classList.contains("single-spazi")) {
        if (!voice[0]?.parentNode?.classList.contains("current-menu-item")) voice[0]?.parentNode.classList.add("current-menu-item");
      } else if (body.classList.contains("lofts-template")) {
        if (!voice[0]?.parentNode?.classList.contains("current-menu-item")) voice[0]?.parentNode.classList.add("current-menu-item");
      }
    }
  }
}